import React, { PureComponent } from 'react'
import qs from 'qs'

import Search from '../search'
import SearchIcon from '../icon/icon'
import Icon from '../../../core/patterns/icon/icon'
import MagnifyingGlass from '../../../resources/svgs/Search.svg'
import Next from '../../../resources/svgs/Arrow.svg'

import autocomplete from '../../../core/api/autocomplete'
import i18n from '../../../core/services/i18n/i18n'

import styles from './inline.css'

export default class InlineSearch extends PureComponent {
	constructor(props, context) {
		super(props, context)
		this.seeAllResultsUrl = '/search'
	}

	styles = {
		wrapper: styles['input'],
		icon: styles['item__list__icon'],
		label: styles['input__label'],
		input: styles['input__control'],
		container: styles['wrapper'],
		loader: styles['loader'],
		list: styles['item__list'],
		listHidden: styles['item__list--hidden'],
		result: styles['item__result'],
		button: styles['cta'],
		buttonIcon: styles['cta__icon'],
		inputClearButton: styles['input__clear'],
		inputClearIcon: styles['input__clear__icon'],
	}

	resultTemplate = ({ result, index, selected }, highlight) => {
		const linkClassName =
			index === selected
				? `${styles['item__link']} ${styles['link--selected']}`
				: styles['item__link']

		let eventText = ''

		if (result.eventCount && result.eventCount > 0 && result.eventCount <= 1) {
			eventText = i18n.get('Search.SingleEvent')
		} else if (result.eventCount && result.eventCount > 1) {
			eventText = i18n.get('Search.Events')
		}

		const extraInfo =
			result.eventCount && result.eventCount > 0
				? `(${result.eventCount} ${eventText.toLowerCase()})`
				: null

		const resultName = result.name
		const resultUrl = result.url
		const resultType = result.type
		const SearchIconComponent = SearchIcon
		const text = highlight(resultName, styles['item__match'])

		return (
			<a href={resultUrl} className={linkClassName}>
				<SearchIconComponent
					width={20}
					height={20}
					type={resultType}
					className={styles['item__icon']}
				/>

				<div className={styles['item__text']}>
					<span
						dangerouslySetInnerHTML={text}
						className={styles['text__wrapper']}
					/>
					<span className={styles['item__date']}>{extraInfo}</span>
				</div>
			</a>
		)
	}

	footerTemplate = value => {
		return (
			<a
				className={styles['allresults']}
				href={`${this.seeAllResultsUrl}?keyword=${value}`}
			>
				{i18n.get('Search.SeeAll')}
				<Icon
					className={styles['allresults__icon']}
					width={15}
					height={15}
					glyph={Next}
				/>
			</a>
		)
	}

	onResultSelected = (result, value) => {
		if (result) {
			window.location.href = result.url
		} else {
			window.location.href =
				'/search' + qs.stringify({ keyword: value }, { addQueryPrefix: true })
		}
	}

	render() {
		return (
			<Search
				styles={this.styles}
				placeholder={i18n.get('FeatureHeader.SearchPlaceholder')}
				buttonText={i18n.get('FeatureHeader.SearchButtonText')}
				noMatchesText={''}
				showButton
				buttonIcon={MagnifyingGlass}
				idSuffix="inline"
				onRequest={autocomplete}
				action={null}
				label={i18n.get('FeatureHeader.SearchButtonText')}
				onResultSelected={this.onResultSelected}
				resultTemplate={this.resultTemplate}
				footerTemplate={this.footerTemplate}
			/>
		)
	}
}
